import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DiscountCodeCheckResponse, OrderDiscountCode } from '../interfaces/order-discount-code';
import { OrderQuoteDTO } from '../interfaces/order-quote';
import { IOrderDiscountCodeFilter } from '../interfaces/order-discount-code-filter';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { EventService } from './event.service';
import { BaseDataService } from './base.data.service';

export interface DiscountCodeSettings {
  minimumDiscountCodePercentage: number;
  maximumDiscountCodePercentage: number;
  minimumDiscountCodeAmount: number;
  maximumDiscountCodeAmount: number;
}

@Injectable({ providedIn: 'root' })
export class DiscountCodeService extends BaseDataService {
  public url = '/api/discount-code';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public extractData(res) {
    return res;
  }

  public getDiscountCodes(filter: IOrderDiscountCodeFilter): Promise<OrderDiscountCode[]> {
    return this.http
      .get(`${this.url}`, { params: this.constructHttpParams(filter) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public getDiscountCodeSettings(): Promise<DiscountCodeSettings> {
    return this.http.get<DiscountCodeSettings>(`${this.url}/settings`).toPromise();
  }

  public patchDiscountCode(id: number, patch: any): Promise<OrderDiscountCode> {
    return this.http
      .patch(`${this.url}/${id}`, patch)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public createDiscountCode(dto: OrderDiscountCode): Promise<OrderDiscountCode> {
    return this.http
      .post(`${this.url}`, dto)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  checkDiscountCode(discountCode: string) {
    return this.http
      .get<DiscountCodeCheckResponse>(`${this.url}/check`, {
        params: { discountCode },
      })
      .toPromise();
  }

  applyDiscountCode(discountCode: string, quoteGuid: string, bookUrgent: boolean) {
    return this.http
      .post<OrderQuoteDTO>(
        `${this.url}/${quoteGuid}/apply-discount-code?discountCode=${discountCode}&bookUrgent=${bookUrgent}`,
        {},
      )
      .toPromise();
  }

  generateDiscountCode(payload: any): Promise<void> {
    return this.http.post<void>(`${this.url}/generate`, payload).toPromise();
  }
}
